<template>
  <div
    id="icarus-benefits"
    class="panel"
  >
    <div class="icarus-icon" />
    <p class="order-benefits">
      <span v-html="$t('checkout:stepone.game_checkout_info.icarus.description')" />
    </p>
  </div>
</template>

<script>
export default {
  name: 'IcarusCheckoutInfo',
};
</script>

<style scoped>

</style>
